import React, { useEffect, useState } from "react";
import {
  Dummyimage1,
  eye_view,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { useLocation, useNavigate } from "react-router-dom";
import { checkPermission } from "../redux/api/PermissionManager";
import { toast } from "react-toastify";
import ReadNotificationPopup from "../../components/ReadNotificationPopup";
import UnReadNotificationPopup from "../../components/UnReadNotificationPopup";
import moment from "moment";
// import { useRef, useState } from "react";

const NotifyMe = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const path = pathname?.replace("/", "");
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({});
  const [count, setCount] = useState(0);
  const [list, setList] = useState([]);
  const [selectedOwners, setSelectedOwners] = useState([]);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [submissionDescription, setSubmissionDescription] = useState("");
  const [isViewDetails, setIsViewDetails] = useState({
    ispopUp: false,
    details: {},
  });
  const [selectedFilter, setSelectedFilter] = useState({
    from: moment().format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD'),
    search: paginationData?.[path]?.search ?? "",
    unread_only: false,
  });

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: {
        page: page,
        search: selectedFilter.search,
      },
    }));
  }, [page, selectedFilter.search, selectedFilter?.unread_only]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  const getList = async (pageNumber = 1) => {
    let { from, search, to, unread_only } = selectedFilter;

    const payload = new FormData();
    if (search) {
      payload.append("search", search);
    }
    if (from && to) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    let res = await post(
      `${URLS.NOTIFYME}?page=${pageNumber}&unread_only=${unread_only}`,
      payload,
    );
    // console.log("wishlist res", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setList(res?.data ?? []);
    }
  };

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ row }) => {
          const pageSize = 10;
          const isSelected = selectedOwners.includes(
            row.original.unread_notification_id,
          );

          const handleCheckboxChange = (e) => {
            if (e.target.checked) {
              setSelectedOwners((prev) => [
                ...prev,
                row.original.unread_notification_id,
              ]);
            } else {
              setSelectedOwners((prev) =>
                prev.filter((id) => id !== row.original.unread_notification_id),
              );
            }
          };

          return (
            <div
              style={{
                flexDirection: "row-reverse",
                alignItems: "center",
                display: "flex",
                gap: 5,
              }}
            >
              <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>
              {row?.original?.has_unread_notification && (
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={handleCheckboxChange}
                  style={{ width: 20, height: 20, marginTop: 9 }}
                />
              )}
              {!row?.original?.has_unread_notification && (
                <img
                  src={eye_view}
                  style={{ width: 20, height: 20, marginTop: 5 }}
                  onChange={() => {
                    setIsViewDetails((prev) => ({
                      ...prev,
                      ispopUp: true,
                      details: row?.original,
                    }));
                  }}
                  onClick={() => {
                    setIsViewDetails((prev) => ({
                      ...prev,
                      ispopUp: true,
                      details: row?.original,
                    }));
                  }}
                />
              )}
            </div>
          );
          // const pageSize = 10;
          // return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "Hotel Category",
        accessor: "hotel_category",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Property",
        accessor: "property_name",
        Cell: ({ value, row }) => {
          return <p style={{ color: "#AE55F5", fontWeight: "600" }}>{value}</p>;
        },
      },
      {
        Header: "Owner",
        accessor: "owner_name",
        Cell: ({ value, row }) => {
          return <p style={{ color: "#AE55F5", fontWeight: "600" }}>{value}</p>;
        },
      },
      {
        Header: " Location",
        accessor: "area",
        Cell: ({ value, row }) => {
          return <p>{`${value},${row.original?.city}`}</p>;
        },
      },
      {
        Header: " Notification Count",
        accessor: "notify_count",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Property Image",
        accessor: "property_image",
        Cell: ({ value, row }) => {
          return (
            <img src={value ?? Dummyimage1} alt="image" className="list-img" />
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              <button
                onClick={() => {
                  navigate("/notifymeview", {
                    state: { property: row.original, type: "view" },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-VIEW-NOTIFY_ME") ? [...d, action] : d;
  }, [page, selectedOwners]);
  const handleSumbit = async () => {
    let payload = {
      ids: selectedOwners,
      description: submissionDescription,
    };

    try {
      let url = URLS.NOTIFICATION_COUNTREDUCE;
      let res = await post(url, payload);
      if (res?.status === "success") {
        // console.log("Description:", submissionDescription);
        toast.success("Read Notification has be Success");
        setShowSubmitPopup(false);
        setSubmissionDescription("");
        setSelectedOwners([]);
        getList();
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
    }
  };
  return (
    <div>
      <Topbar header={"Notify Me"} />
      <div className="d-flex ac-jb">
        <div
          className="d-flex mb-4"
          style={{
            flexDirection: "row",
            // justifyContent: "space-between",
            alignItems: "center",
            gap: 50,
            width: "100%",
          }}
        >
          <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
            Total:{count}
          </h2>
          <div className="d-flex" style={{ alignItems: "center" }}>
            <input
              type="checkbox"
              checked={selectedFilter?.unread_only}
              onChange={() =>
                handleChangeFilter("unread_only", !selectedFilter?.unread_only)
              }
            />{" "}
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 ">
              Check New Notification
            </p>
            {/* <Select
            className="location-search"
            options={[{ label: "New to Old", value: "newtoold" }]}
            isClearable
            // onChange={(e) => {
            //   handleChangeFilter("property", e);
            // }}
            // value={selectedFilter?.property}
            placeholder={"property"}
          /> */}
          </div>
        </div>
        {/* <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{count}
        </h2> */}

        <div className="d-flex ac-js mt-3 gap-4 flex-wrap">
          <DateRange
            currentDay={true}
            setFromDate={(date) => {
              handleChangeFilter("from", date);
            }}
            setToDate={(date) => {
              handleChangeFilter("to", date);
            }}
          />

          <div className="search-input">
            <input
              onChange={(e) => {
                handleChangeFilter("search", e.target.value);
              }}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
              value={selectedFilter.search}
            />
            <img alt="" src={Search_icon} className="search" />
          </div>
        </div>
      </div>
      {selectedOwners.length > 0 && (
        <div
          className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn mt-2 "
          style={{ width: 90 }}
          onClick={() => setShowSubmitPopup(true)}
        >
          <p>Submit</p>
        </div>
      )}
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        getRowProps={(row) => ({
          style: {
            backgroundColor: row.original.has_unread_notification
              ? "#eeeeee91"
              : "#fff",
          },
        })}
        show={true}
      />
      {showSubmitPopup && (
        <ReadNotificationPopup
          setSubmissionDescription={setSubmissionDescription}
          setShowSubmitPopup={setShowSubmitPopup}
          submissionDescription={submissionDescription}
          handleSumbit={handleSumbit}
        />
      )}
      {isViewDetails?.ispopUp ? (
        <UnReadNotificationPopup
          setIsViewDetails={setIsViewDetails}
          isViewDetails={isViewDetails}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default NotifyMe;
